import { render, staticRenderFns } from "./AddHostel.vue?vue&type=template&id=64027931&"
import script from "./AddHostel.vue?vue&type=script&lang=ts&"
export * from "./AddHostel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports